const baseurl = "https://nodebalancer.pratibhotsava.rocks/registration";
export default baseurl;
